<template>
  <div class="grid-container property-listing">
		<div class="grid-x">
    <FilterTool v-if="this.componentLoaded"
                :descFilterValue="descFilterValue"
                :propertiesFound="getPropertiesFound"
                :minPrice="getMinPrice"
                :maxPrice="getMaxPrice"
                :minSurface="getMinSurface"
                :maxSurface="getMaxSurface"
                :minRoom="getMinRoom"
                :maxRoom="getMaxRoom"
                :citiesOptions="getCities"
                :typeOptions="getType"                
                @filter-multiple="getfilteredData"
                @reinit-filter="reinitFilter"/>                

    <ListProperty v-if="this.componentLoaded" 
              :properties="filteredData" />
    <AlertMessage v-if="!this.componentLoaded" 
                  :messageInfo="messageInfo" />
    </div>
  </div>  
</template>

<script>
// import data from './data/data';
import ListProperty from './components/ListProperty.vue';
import FilterTool from './components/FilterTool.vue';
import AlertMessage from './components/AlertMessage';

export default {
  name: 'App',
  components: {
    ListProperty,
    FilterTool,
    AlertMessage
  },
  data() {
      return {  
        data: [],      
        filteredData: [],
        componentLoaded: false,
        descFilterValue: '',
        cityFilterValue: '',
        typeFilterValue: '',
        priceFilterValue01: 0,
        priceFilterValue02: 0,
        surfaceFilterValue01: 0,
        surfaceFilterValue02: 0,
        roomFilterValue01: 0,
        roomFilterValue02: 0,        
        filterTypeExternal: '',
        messageInfo: 'loading',
      }
  },
  methods: {
   async getData() {
       await fetch('/vcatalog/json/')
        .then((r) => r.json())
        .then((res) => {
          //If wordpress send us some data, we iniate values and filter, display components
          if(res.length > 0) {
            this.data = res;
            this.filteredData = this.data;            
            this.componentLoaded = true;
            //init filter value
            this.initFiltersValue();
            //get filter receive by url
            let uri = window.location.search.substring(1); 
            let params = new URLSearchParams(uri);
            this.filterTypeExternal = params.get("type") !=null ? params.get("type") : null;
            // console.log("data ready - filter ?" + this.filterTypeExternal);
          } else {
            this.messageInfo = "Aucun biens immobiliers pour le moment";
          }
          
          }).catch( error => {
            this.messageInfo = "Une erreur est survenue " + error; 
          });
    },
    getfilteredData: function(search) {

      switch (search.type) {
        case 'desc':
          this.descFilterValue = search.value.toLowerCase().trim();
          break;
        case 'city':
          this.cityFilterValue = search.value.toLowerCase().trim();
          break;
        case 'cityOption':
          // this.cityFilterValue = search.value.toLowerCase().trim();
          this.cityFilterValue = search.value;
          break;
        case 'price': 
          this.priceFilterValue01 = parseInt(search.value);  
          this.priceFilterValue02 = parseInt(search.value02);
          break;
        case 'type':
          this.typeFilterValue = search.value;
          break;
        case 'surface':
          this.surfaceFilterValue01 = parseInt(search.value);  
          this.surfaceFilterValue02 = parseInt(search.value02);
          break;
        case 'room':
          this.roomFilterValue01 = parseInt(search.value);  
          this.roomFilterValue02 = parseInt(search.value02);
          break;
      }
      //filter data with different values emit by the filter tool
      this.filteredData = this.data.filter(item => {
        return (item.desc.toLowerCase().indexOf(this.descFilterValue) > -1)
                //&& (item.city.toLowerCase().indexOf(this.cityFilterValue) > -1)
                && (this.cityFilterValue.indexOf(item.city) > -1)
                && (this.typeFilterValue.indexOf(item.type) > -1)
                && (parseInt(item.price) >= this.priceFilterValue01 && parseInt(item.price) <= this.priceFilterValue02)
                && (parseInt(item.surface) >= this.surfaceFilterValue01 && parseInt(item.surface) <= this.surfaceFilterValue02)
                && (parseInt(item.room) >= this.roomFilterValue01 && parseInt(item.room) <= this.roomFilterValue02);        
      });
    },
    reinitFilter: function(defaultTypeOption, defaultCitiesOption) {
      let simpleValueCityOption = defaultCitiesOption.map(item => item.value);
      console.log("reinit filter ", defaultTypeOption, simpleValueCityOption)
      this.initFiltersValue();
      this.typeFilterValue = defaultTypeOption; //get all option type
      this.cityFilterValue = simpleValueCityOption; //get all option type
      this.getfilteredData({type:"default", value:""});
    },
    initFiltersValue: function() {
      this.descFilterValue = '';
      this.cityFilterValue = '';  
      this.surfaceFilterValue01 = this.getMinSurface;
      this.surfaceFilterValue02 = this.getMaxSurface;
      this.roomFilterValue01 = this.getMinRoom;
      this.roomFilterValue02 = this.getMaxRoom;
      this.priceFilterValue01 = this.getMinPrice;
      this.priceFilterValue02 = this.getMaxPrice;         
    }

  }, 
  computed: {
    getPropertiesFound() {
      return this.filteredData.length;
    },
    getMinPrice() {
      if(! this.componentLoaded)
        return null;
            
      return this.data.reduce((prev, current) => Math.min(prev, current.price), this.data[0].price);     
    },  
    getMaxPrice() {
      if(! this.componentLoaded)
        return null;
      
      return this.data.reduce((prev, current) => Math.max(prev, current.price), this.data[0].price);           
    },
    getMinSurface() {
      if(! this.componentLoaded)
        return null;
            
      return this.data.reduce((prev, current) => Math.min(prev, current.surface), this.data[0].surface);  
    },
    getMaxSurface() {
      if(! this.componentLoaded)
        return null;     
      
      return this.data.reduce((prev, current) => Math.max(prev, current.surface), this.data[0].surface); 
    },
    getMinRoom() {
      if(! this.componentLoaded)
        return null;
            
      return this.data.reduce((prev, current) => Math.min(prev, current.room), this.data[0].room);  
    },
    getMaxRoom() {
      if(! this.componentLoaded)
        return null;     
      
      return this.data.reduce((prev, current) => Math.max(prev, current.room), this.data[0].room); 
    },
    getType() {
      
      /* Return Type of Properties Options */
      let options = this.data
                    .reduce((unique, item) => unique.includes(item.type) ? unique : [...unique, item.type], [])
                    .map(p => {
                      let typeObj = {};
                      let booleanTypeFilter = this.filterTypeExternal == p || this.filterTypeExternal == null ? true : false;                      
                      typeObj["text"] = p;                      
                      typeObj["value"] = booleanTypeFilter;
                      return typeObj;
                    });
      // console.log("getype called ", options)           
      return options;
    },
    getCities() {
      /* Return List of cities for Options */
      let options = this.data
                    .reduce((unique, item) => unique.includes(item.city) ? unique : [...unique, item.city], [])
                    .map(p => {
                      let typeObj = {};
                      // let booleanTypeFilter = this.filterTypeExternal == p || this.filterTypeExternal == null ? true : false;                      
                      typeObj["text"] = p;                      
                      typeObj["value"] = p;
                      return typeObj;
                    }); 
      //options.unshift({text:"Toutes", value:"all"}); // Add            
      //console.log("options city getCities ", options);           
      return options;
    }
  },
  mounted() {   
   this.getData();   
  },
  
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  min-height: 300px;
}
.grid-x {
  /* max-width: 1200px; */
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}
.medium-3 {
  flex: 0 0 25%;
  margin-bottom: 50px;
}
.medium-9 {
  flex: 0 0 75%;
}
@media screen and (max-width: 640px) {
  /* .grid-x {
    flex-direction: column;
  } */
  .medium-3, .medium-9 {
    flex: 0 0 100%
  }
}
</style>
